module.exports = __webpack_public_path__ + "static/media/ico_bank_512.4e4d4bd5.png";